module.exports = __webpack_public_path__ + "img/icon_xiajiang_red.1b3b7b66.svg";